module.exports = __webpack_public_path__ + "img/industry-standards.bc06d4c9.svg";